import React, { Component } from "react";

export default class DesignImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="fashion-sketch-easel"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="500"
        height="400"
        viewBox="0 0 500 400"
      >
        <title>fashion sketch</title>

        <ellipse cx="250" cy="388" rx="140" ry="8" fill="#e6e6e6" opacity="0.5" />

        {/* easel legs */}
        <line x1="250" y1="60" x2="150" y2="380" stroke={theme.dark} strokeWidth="6" strokeLinecap="round" />
        <line x1="250" y1="60" x2="350" y2="380" stroke={theme.dark} strokeWidth="6" strokeLinecap="round" />
        <line x1="250" y1="60" x2="250" y2="390" stroke={theme.dark} strokeWidth="4" opacity="0.5" />

        {/* canvas / sketch pad */}
        <rect x="140" y="70" width="220" height="260" rx="6" fill="#f2f2f2" stroke={theme.text} strokeWidth="3" />

        {/* fashion croquis sketch */}
        <circle cx="250" cy="120" r="18" fill="none" stroke={theme.text} strokeWidth="2.5" />
        <line x1="250" y1="138" x2="250" y2="148" stroke={theme.text} strokeWidth="2.5" />
        <line x1="228" y1="155" x2="205" y2="200" stroke={theme.text} strokeWidth="2.5" strokeLinecap="round" />
        <line x1="272" y1="155" x2="295" y2="200" stroke={theme.text} strokeWidth="2.5" strokeLinecap="round" />
        <polygon points="228,150 272,150 285,300 215,300" fill={theme.imageHighlight} stroke={theme.text} strokeWidth="2" />
        <line x1="222" y1="210" x2="278" y2="210" stroke={theme.text} strokeWidth="2" />
        <line x1="235" y1="300" x2="232" y2="340" stroke={theme.text} strokeWidth="2.5" strokeLinecap="round" />
        <line x1="265" y1="300" x2="268" y2="340" stroke={theme.text} strokeWidth="2.5" strokeLinecap="round" />
        <line x1="305" y1="95" x2="335" y2="95" stroke={theme.text} strokeWidth="2" opacity="0.4" />
        <line x1="305" y1="105" x2="325" y2="105" stroke={theme.text} strokeWidth="2" opacity="0.4" />
        <line x1="305" y1="115" x2="332" y2="115" stroke={theme.text} strokeWidth="2" opacity="0.4" />

        {/* ledge the canvas rests on */}
        <line x1="175" y1="330" x2="325" y2="330" stroke={theme.dark} strokeWidth="8" strokeLinecap="round" />

        {/* measuring tape draped over the corner */}
        <path
          d="M330,70 Q380,40 420,80 Q440,100 410,140 Q390,165 350,150"
          fill="none"
          stroke={theme.imageHighlight}
          strokeWidth="10"
          strokeLinecap="round"
        />
        <path
          d="M330,70 Q380,40 420,80 Q440,100 410,140 Q390,165 350,150"
          fill="none"
          stroke={theme.text}
          strokeWidth="1"
          strokeDasharray="2 6"
          opacity="0.5"
        />

        {/* fabric swatches */}
        <rect x="60" y="320" width="46" height="46" rx="6" fill={theme.imageHighlight} transform="rotate(-8 83 343)" />
        <rect x="80" y="335" width="46" height="46" rx="6" fill={theme.highlight} transform="rotate(6 103 358)" />
        <g transform="rotate(-4 123 373)">
          <rect x="100" y="350" width="46" height="46" rx="6" fill={theme.dark} />
          <circle cx="112" cy="362" r="3" fill="#f2f2f2" />
          <circle cx="128" cy="362" r="3" fill="#f2f2f2" />
          <circle cx="112" cy="378" r="3" fill="#f2f2f2" />
          <circle cx="128" cy="378" r="3" fill="#f2f2f2" />
        </g>

        {/* thread spool */}
        <rect x="380" y="330" width="18" height="24" rx="3" fill={theme.imageHighlight} />
        <ellipse cx="389" cy="330" rx="9" ry="4" fill={theme.highlight} />
        <ellipse cx="389" cy="354" rx="9" ry="4" fill={theme.highlight} />
      </svg>
    );
  }
}
